import { IAlert } from '../../alerts.t';
import {
    TriggeredAlertNotificationHeaderStyled,
    TriggeredAlertNotificationIconStyled,
    TriggeredAlertNotificationPriceStyled,
    TriggeredAlertNotificationStyled,
    TriggeredAlertNotificationTitleStyled,
} from './styled/TriggeredAlertNotificationStyled';
import BinIcon from '../../../../components/icon/IconWrapped';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { Button } from 'react-bootstrap';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { locationSlice } from '../../../Location/locationReducer';
import { LOCATION_NAMES } from '../../../Location/locationConstants';
import { toast } from 'react-toastify';

interface ITriggeredAlertNotificationProps {
    alert: IAlert;
}

function TriggeredAlertNotification(props: ITriggeredAlertNotificationProps) {
    const { alert } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();

    const onButtonClickHandler = useCallback(() => {
        toast.dismiss();
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.ASSET,
            searchParams: { symbol: alert.symbol },
        }));
    }, [alert, dispatch]);

    return <TriggeredAlertNotificationStyled>
        <TriggeredAlertNotificationHeaderStyled>
            <TriggeredAlertNotificationIconStyled>
                <BinIcon name={'IcBellFilled'} size={16}/>
            </TriggeredAlertNotificationIconStyled>

            <TriggeredAlertNotificationTitleStyled>
                {getLangPath('alerts.symbol_alert', { symbol: alert.symbol })}
            </TriggeredAlertNotificationTitleStyled>

            <TriggeredAlertNotificationPriceStyled>
                {alert.price}
            </TriggeredAlertNotificationPriceStyled>
        </TriggeredAlertNotificationHeaderStyled>

        <span className={'text-secondary'}>
            {getLangPath('alerts.triggered_alert_description')}
        </span>

        <Button variant={'secondary'} size={'sm'} onClick={onButtonClickHandler}>
            <div className={'d-flex align-items-center justify-content-center'}>
                <span>{getLangPath('alerts.triggered_alert_button')}</span>
                <BinIcon className={'ms-2'} name={'IcForward'} size={16}/>
            </div>
        </Button>
    </TriggeredAlertNotificationStyled>;
}

export default TriggeredAlertNotification;
